import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const TrainingReportFlagRouter = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-27700_specialized-lesson-completion-updates',
  ],
  OnComponent,
  OffComponent,
})

export default TrainingReportFlagRouter
